// Import modules
import data from '../data/steps.json'
import * as d3 from 'd3';

// Console Log to see data
// console.log(data);

data.forEach(d => {
d.date = new Date(d.date);
})

// Milestones Data ---------------------------------------------------------------------
const milestones = 
[
{id: "halfway",
title: "Half Way",
date: "2024-05-31",
value: 419024,
type: "milestone",
description: "2.5m steps walked on 31 May, 425k steps ahead of target"
},
{
id: "100k-day",
title: "100k Step Day",
date: "2024-06-21",
value: 610000,
type: "point",
description: "100k steps in one day to earn the 'Olympic Sandals' FitBit badge"
},
{
id: "five-million",
title: "5 Million Steps",
date: "2024-11-12",
value: 659399,
type: "milestone",
description: "Completed! 5m steps walked on 12 Nov, 671k steps ahead of target"

},
{
id: "final",
title: "Final Count",
date: "2024-12-31",
value:571039,
type: "milestone",
description: "Final step count: 5.585m. 585k ahead of target"
}];

// SVG Dimensions ---------------------------------------------------------------------
const width = 800;
const height = 400;
const margin = {
top: 50,
right: 50,
bottom: 50,
left: 50
};

const chartWidth = width - margin.left - margin.right;
const chartHeight = height - margin.top - margin.bottom;

const topGridLine = 8500000;

// Milestones Data ---------------------------------------------------------------------
d3.select(".milestones-list")
.selectAll(".milestone")
.data(milestones)
.enter()
.append("div")
.attr("class", "milestone")
.text(d => d.title)
.on("mouseover", (event, d) => {
d3.select(".milestone-description")
.text(d.description);
if (d.type === "milestone") {
const x = xScale(new Date(d.date));
svg.append("line")
.attr("class", "milestone-line")
.attr("x1", x)
.attr("x2", x)
.attr("y1", yScale(topGridLine))
.attr("y2", yScale(0))
// .attr("stroke", "#5f7a61")
// .attr("stroke-width", 3)
.attr("opacity", 0)
.transition()
.duration(600)
.attr("opacity", 0.75);
}
if (d.type === "point") {
const x = xScale(new Date(d.date));
svg.append("circle")
.attr("class", "milestone-circle")
.attr("cx", x)
.attr("cy", yScale(d.value))
.attr("r", 35)
.attr("opacity", 0)
.transition()
.duration(600)
.attr("opacity", 1);
}
})
.on("mouseout", () => {
d3.select(".milestone-description")
.text("");
svg.selectAll(".milestone-line")
.transition()
.duration(300)
.attr("opacity", 0)
.remove();
svg.selectAll(".milestone-circle")
.transition()
.duration(300)
.attr("opacity", 0)
.remove();
});

// Append SVG ---------------------------------------------------------------------
const svg = d3.select(".steps")
.append("svg")
.attr("width", width)
.attr("height", height)

// Line Glow ---------------------------------------------------------------------
const defs = svg.append("defs");
const glow = defs.append("filter")
.attr("id", "glow");

glow.append("feGaussianBlur")
.attr("stdDeviation", 3)
.attr("result", "coloredBlur");

const merge = glow.append("feMerge");
merge.append("feMergeNode")
.attr("in", "coloredBlur");

merge.append("feMergeNode")
.attr("in", "SourceGraphic");

// Define X and Y Scales ---------------------------------------------------------------------
const xScale = d3.scaleTime()
.domain(d3.extent(data, d => d.date))
.range([margin.left, width - margin.right]);

const yScale = d3.scaleLinear()
.domain(d3.extent(data, d => d.progress))
.range([height - margin.bottom, margin.top]);

// Define line and Append ---------------------------------------------------------------------
const line = d3.line()
.x((d,i) => xScale(d.date))
.y(d => yScale(d.progress));

svg.append("path")
.datum(data)
.attr("class", "steps-line")
.attr("filter", "url(#glow)")
.attr("d", line)
.attr("opacity", 0)
.transition()
.delay(100)
.duration(2000)
.attr("opacity", 1);

// Define and Append grids ---------------------------------------------------------------------
const yGrid = d3.axisLeft(yScale)
.ticks(4)
.tickSize(-width)
.tickFormat("");

svg.append("g")
.attr("class", "grid")
.attr("transform", `translate(${margin.left},0)`)
.call(yGrid);

const xGrid = d3.axisBottom(xScale)
.ticks(4)
.tickSize(-height)
.tickFormat("");

svg.append("g")
.attr("class", "grid")
.attr("transform", `translate(0, ${height - margin.bottom})`)
.call(xGrid);

// Define and Append Axes  ---------------------------------------------------------------------
const yAxis = d3.axisLeft(yScale)
.ticks(6)
.tickFormat(d => `+${d / 1000}k`);
svg.append("g")
.attr("class", "axis")
.attr("transform", `translate(${margin.left},0)`)
.call(yAxis);

const xAxis = d3.axisBottom(xScale)
.ticks(d3.timeMonth.every(1))
.tickFormat(d3.timeFormat("%b"));
svg.append("g")
.attr("class", "axis")
.attr("transform", `translate(0, ${height - margin.bottom})`)
.call(xAxis);